import type { HelpFile } from '../../types/help'
import { RestConfigEditDialogTestIds } from '../../../testids/RestConfigEditDialogTestIds'

export const restConfigEditDialogHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [RestConfigEditDialogTestIds.btnSaveRestConfig]:
      'Save the REST connection settings.',
    [RestConfigEditDialogTestIds.btnSaveScimConfig]:
      'Save the SCIM configuration.',
    [RestConfigEditDialogTestIds.btnCancelRestConfig]:
      'Discard pending changes to REST connection settings.',
    [RestConfigEditDialogTestIds.btnCancelScimConfig]:
      'Discard pending SCIM configuration changes.',
    [RestConfigEditDialogTestIds.inputItemsJsonPath]:
      'JSON path or XML element path to the items array. Disabled for CSV and TEXT formats.',
    [RestConfigEditDialogTestIds.selectResponseFormat]:
      'Pick the body format the source system returns. Switching to CSV or TEXT clears the items path.',
    [RestConfigEditDialogTestIds.selectPaginationStyle]:
      'Select pagination style — cursor, offset, or page-based.',
    [RestConfigEditDialogTestIds.responseFormatJson]: null,
    [RestConfigEditDialogTestIds.responseFormatXml]: null,
    [RestConfigEditDialogTestIds.responseFormatCsv]: null,
    [RestConfigEditDialogTestIds.responseFormatText]: null,
    [RestConfigEditDialogTestIds.authTypeChangeWarning]:
      'Warning shown when changing auth type — switching may clear secret references.',
    [RestConfigEditDialogTestIds.authTypeOptionAwsSigv4]: null,
    [RestConfigEditDialogTestIds.authTypeOptionMutualTls]: null,
    [RestConfigEditDialogTestIds.authTypeOptionNtlmKerberos]: null,
    [RestConfigEditDialogTestIds.authTypeOptionSignedRequest]: null,
    [RestConfigEditDialogTestIds.authTypeOptionGoogleSaJwt]: null,
    [RestConfigEditDialogTestIds.googleSaSectionHelp]: null,
    [RestConfigEditDialogTestIds.inputGoogleDelegatedUser]:
      'The Google Workspace admin account this integration impersonates. Use a dedicated non-human admin (e.g. iam-sync@your-domain.com) — a personal account will stop working if that person leaves.',
    [RestConfigEditDialogTestIds.inputGoogleSaEmail]:
      'The service account\'s email address (found in Google Cloud Console under IAM → Service Accounts).',
    [RestConfigEditDialogTestIds.inputGoogleSaKeySecretRef]:
      'Secret reference to the service account RSA private key (PKCS#8 PEM). The form shows only the reference name — the resolved key is never displayed.',
    [RestConfigEditDialogTestIds.inputGoogleTokenScope]:
      'Space-separated OAuth scopes. For read-only user sync: https://www.googleapis.com/auth/admin.directory.user.readonly',
    [RestConfigEditDialogTestIds.inputAwsAccessKeySecretRef]:
      'Reference to the AWS access key secret used to sign requests.',
    [RestConfigEditDialogTestIds.inputAwsRegion]:
      'AWS region for SigV4 signing (for example, us-east-1).',
    [RestConfigEditDialogTestIds.inputAwsSecretKeySecretRef]:
      'Reference to the AWS secret key secret used to sign requests.',
    [RestConfigEditDialogTestIds.inputAwsService]:
      'AWS service name for SigV4 signing (for example, execute-api).',
    [RestConfigEditDialogTestIds.inputClientCertSecretRef]:
      'Reference to the client certificate secret used for mutual TLS.',
    [RestConfigEditDialogTestIds.inputClientKeySecretRef]:
      'Reference to the client private key secret used for mutual TLS.',
    [RestConfigEditDialogTestIds.inputKerberosKeytabSecretRef]:
      'Reference to the Kerberos keytab secret used for authentication.',
    [RestConfigEditDialogTestIds.inputKerberosPrincipal]:
      'Kerberos principal name (user@REALM).',
    [RestConfigEditDialogTestIds.inputKerberosRealm]:
      'Kerberos realm associated with the principal.',
    [RestConfigEditDialogTestIds.inputSigningHeaderTemplate]:
      'HTTP header template for signed-request authentication; supports placeholders for the signature.',
    [RestConfigEditDialogTestIds.inputSigningKeySecretRef]:
      'Reference to the signing key secret used to compute request signatures.',
    [RestConfigEditDialogTestIds.inputTruststoreSecretRef]:
      'Reference to the truststore containing the server certificate authority for mutual TLS.',
    [RestConfigEditDialogTestIds.kerberosSectionHelp]: null,
    [RestConfigEditDialogTestIds.mtlsSectionHelp]: null,
    [RestConfigEditDialogTestIds.signedRequestSectionHelp]: null,
    [RestConfigEditDialogTestIds.sigv4SectionHelp]: null,
    [RestConfigEditDialogTestIds.restApiKeySecretRef]:
      'Reference to the API key secret sent on every request.',
    [RestConfigEditDialogTestIds.restClientSecretRef]:
      'Reference to the OAuth2 client secret.',
    [RestConfigEditDialogTestIds.restPasswordSecretRef]:
      'Reference to the password secret for Basic authentication.',
    [RestConfigEditDialogTestIds.restTokenSecretRef]:
      'Reference to the bearer token secret.',
    [RestConfigEditDialogTestIds.selectSigningAlgorithm]:
      'Algorithm used to compute the request signature.',
  },
}
